export const MINIMUM_SCREEN_SIZE_TABLET = 768

export const MINIMUM_SCREEN_SIZE_DESKTOP = 1200
